// DTO for the POWUser to be sent to POW
export interface PowUserResponse {
	// The AD UserPrincipalName for the PowUser. Usually email address
	userPrincipalName: string;

	// Flag to indicate if this user is a PDP Global Administrator (meaning they get access to everything)
	pdpGlobalAdministrator: boolean;

	// Creation date for the user.
	createdDate: Date;

	// Date that the user ws last updated.
	lastUpdatedDate: Date;

	// user who created the pow user.
	createdBy: string;

	// user who last updated the pow user.
	lastUpdatedBy: string;

	// A dictionary filled with the POWRole names and Id's that the user is authorized for.
	// IDictionary<string, Guid>
	powRoles: object;

	// A dictionary filled with the product names and Id's that the usr is authorized for.
	// IDictionary<string, Guid>
	products: object;
}

// DTO returned to displayed all the products in POW user management.
export interface UserManagementProductResponse {
	// Name of the product.
	productName: string;

	// Id of the product.
	productId: string;

	// The dscription of the product to be displayed in pow.
	productDescription: string;

	// A dictionary of the PowRole Names as well as their corresponding <see cref="UserManagementPowRoleResponse"/>
	// Dictionary<string, UserManagementPowRoleResponse>
	powRoles: object;
}

// DTO for displaying POWRoles in POW.
// used <see cref="UserManagementProductResponse"/>
export interface UserManagementPowRoleResponse {
	// Name of the POW Role
	roleName: string;

	// Id of the ProductXPowRole table entry.
	productXPowRoleId: string;

	// A List of the Pow Features that this role grants.
	powFeatures: UserManagementPowFeatureResponse[];
}

// DTO for displaying a pow feature in POW user management.
// Used <see cref="UserManagementPowRoleResponse"/>
export interface UserManagementPowFeatureResponse {
	// The name of the pow feature.
	powFeatureName: string;

	// The description of the pow feature.
	description: string;
}

// DTO class recieved when front end contacts PDP to change a users name or edit their authorized roles.
export interface EditPowUserRequest {
	// If this is different than the given UserPrincipalname the user's name will be changed to this name.
	userPrincipalName: string;

	// A list of all the edits that are to be made to a pow users roles.
	editRequests: EditPowUserRoleRequest[];
}

// The DTO for editing a user role. Used in <see cref="EditPowUserRequest"/>
export interface EditPowUserRoleRequest {
	// The Id for the ProductRole to edit.
	productRoleId: string;

	// The action to be taken on this role. Either add or delete.
	actionType: AuditActionType;
}

// This enumeration is used to determine what kind of audit action is taking place when editing a PowUser.
export enum AuditActionType {
	CreateUser,
	DeleteUser,
	AddRole,
	RemoveRole,
}

// DTO for EditPowUser endPoint response. Contains a dictionary of all the steps that failed in the edit proccess.
export interface EditPowUserResponse {
	/// A List of all the failed add actions that occurred while attempting to edit the user.
	failedAddActions: string[];

	/// A List of all the failed remove actions that occurred while attempting to edit the user.
	failedRemoveActions: string[];

	/// A boolean that indicates whether or not the change to the user name failed.
	failedUserNameChange: boolean;
}

/// DTO for User Audit records.
export interface UserAuditHistoryResponse {
	/// The type of action that the audit record is.
	actionType: AuditActionType;

	/// The name of the product that this record was connected to.
	/// Is null when audit affects user as a whole.
	productName: string;

	/// The role that was added or removed in this audit step.
	roleName: string;

	/// The user that caused the audit record.
	actionUser: string;

	/// The date of the action.
	actionDate: Date;
}

export interface QueueLogLevelChangeRequest {
	// The target service to update.
	targetService: string;
	// The new logging level threshold.
	threshold: number;
}

export interface UpdateServiceLogLevelResponse {
	// The target service to update.
	serviceName: string;
	// The new logging level threshold.
	success: boolean;
}

export interface UpdateServiceLogLevelResponseObject {
	//The user that made the changes.
	userName: string;
	//the results of the updates.
	responses: string;
}

export interface ServiceLogLevelResponse {
	//The level of the log.
	logLevel: string;
	//the name of the service
	serviceName: string;
	// the latest updated date
	updatedDate: Date;
	// the last person to update the log level
	updatedBy: string;
}
